module.exports = __webpack_public_path__ + "img/logo-dark-url.f095ee82.png";